// Generated by Melange

import * as Caml_int32 from "melange.js/caml_int32.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__StartPlaying from "./startPlaying.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const state = param.store.getState();
    const queued = state.player.queuedSongIds;
    const len = queued.length;
    const currentIndex = Stdlib__Option.value(Stdlib__Option.map((function (value) {
      return queued.indexOf(value, undefined);
    }), state.player.currentSongId), 0);
    const current = queued[Caml_int32.mod_(currentIndex + 1 | 0, len)];
    return StoreFx__StartPlaying.make(current, undefined, undefined);
  }));
}

export {
  make,
}
/* StoreFx__StartPlaying Not a pure module */
